'use strict';

module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./src/util/cookies/browser_cookies.js
 ** module id = 20
 ** module chunks = 0
 **/